export default __webpack_public_path__ + "static/media/Rule Book.77ebdc2b.pdf";